import React, { useState } from "react";
import { Modal } from "antd";
import TourDateSelectorV3 from "./TourDateSelector";
import FlightScheduleV3 from "./FlightScheduleV3";
import PriceChartV3 from "./PriceChartV3";
import PromoBannerV3 from "./PromoBannerV3";
import CruiseCabinSelectorV3 from "./CruiseCabinSelector";
import { CruiseDeparture, Itinerary, Tour } from "../../../interfaces/itinerary.interface";
import { currencyDisplay } from "../../../utils/helpers";
import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";

interface DepartureDateProps {
  dates: any[];
  selectedDate: string;
  selectedTourCode?: string;

  onSelectDate: (params: {
    date: string;
    code: string;
    id: number | null,
    updateItieraryData?: boolean;
  }) => void;
  category: string;
  isNew?: boolean;
  isLoading?: boolean;
  isMobile?: boolean;

  flights?: any[];
  guaranteedDeparture?: boolean;
  arrowLeft?: number;

  priceCurrency?: string;
  prices?: any[];
  roomTypes?: any;
  selectedTour?: Tour | null;
  itinerary?: Itinerary | null;
   
  hasCabinNavigation: boolean;
  cruiseDeparture: CruiseDeparture | undefined;
  cruiseMultiplier: number | undefined;
  cruiseTourId: number | undefined;
  cruiseTourDetailLoading: boolean;
  selectCruiseRoomType: (roomType: any) => void;
  selectCruiseCabin:(cabin: any) => void;
  setDrawerPriceChart:()=> void;
  onNext?: () => void;
}

const DepartureDate: React.FC<DepartureDateProps> = ({
  dates,
  selectedDate,
  selectedTourCode,
  onSelectDate,
  category,
  isNew,
  isLoading,
  isMobile,
  flights = [],
  guaranteedDeparture,
  arrowLeft = 65,
  priceCurrency = "MYR",
  prices = [],
  roomTypes,
  
  selectedTour,
  itinerary,
  
  hasCabinNavigation,
  cruiseDeparture,
  cruiseMultiplier,
  cruiseTourId,
  cruiseTourDetailLoading,
  selectCruiseRoomType,
  selectCruiseCabin,
  setDrawerPriceChart,
  onNext
}) => {
  const [showPriceChart, setShowPriceChart] = useState(false);
  const [modalDates, setModalDates] = useState(dates);
  const [isLoading1, setIsLoading] = useState(isLoading);
  const hasSelectedDate = !!selectedDate;
  const promoPrice = selectedTour?.prices?.find((p: any) => p.type?.startsWith("promo"));
  const normalPrice = selectedTour?.prices?.find((p: any) => p.type === "normal");
  const [showAllTags, setShowAllTags] = useState(false);
  
  const checkoutDisabled = itinerary?.checkoutEnabled === false;
  const checkoutMessage = itinerary?.checkoutDisabledMessage || "Only Customer can make bookings on this portal. Please log out to book as a customer.";
  
  // selectedTour.price is already currency-formatted where it exists (regular series tours).
  // Cruise cabin tours never have a top-level .price at all, so fall back to the same
  // prices[] source PromoBannerV3 uses, formatted the same way everything else on the page is.
  const basePrice = selectedTour?.price ? String(selectedTour.price)  : (promoPrice || normalPrice)?.adult != null
      ? currencyDisplay(itinerary?.priceCurrency, (promoPrice || normalPrice)?.adult) : null;
      
  return (
    <>
      <div id="departure-date" className="page-section departure-date">
        <span className="section-label">
          Departure Date {hasSelectedDate} 
        </span>
        {checkoutDisabled && (
          <div className="v3-checkout-disabled-banner">
            <Icon path={mdiInformationOutline} size={1} />
            <span>{checkoutMessage}</span>
          </div>
        )}
        <TourDateSelectorV3
          dates={modalDates}
          selectedDate={selectedDate}
          selectedTourCode={selectedTourCode}
          selectTour={(tour)=>onSelectDate(tour)}
          category={category}
          isNew={!!isNew}
          isLoading={!!isLoading1}
          isMobile={!!isMobile}
        />
        {hasSelectedDate && flights.length > 0 && prices.length > 0 &&  (
          <>
            <div className="departure-date__details">
              <div className="departure-date__flights">
                <FlightScheduleV3
                  flights={flights}
                  guaranteedDeparture={guaranteedDeparture}
                  arrowLeft={arrowLeft}
                  isMobile={isMobile}
                />
                <button type="button"
                  className="departure-date__flights_next-btn"
                  disabled={isLoading || checkoutDisabled}
                  onClick={onNext}
                >
                  Next
                </button>
              </div>
              <aside className="departure-date__prices">
                <div className="price-details-card">
                    <div className="price-details-card__arrow" />
                    <div className="price-details-card__body">
                        <img className="price-details-card_bg-1" src="/iceholidays-assets/images/v3/price-detail-bg-1.svg" alt="" aria-hidden="true" />
                        <img className="price-details-card_bg-2" src="/iceholidays-assets/images/v3/price-detail-bg-2.svg" alt="" aria-hidden="true" />

                        <div className="price-details-card__header">
                            <div className="price-details-card__title">
                              <span className="price-details-card__icon">
                                <img src="/iceholidays-assets/images/v3/price-icon.svg" alt="$" aria-hidden="true" />
                              </span>
                              <span>Price Details</span>
                            </div>
                            <button type="button"
                              className="price-details-card__expand"
                              onClick={()=>setShowPriceChart(true)}
                            >
                              <img src="/iceholidays-assets/images/v3/expand-icon.svg" alt="expand" aria-hidden="true" />
                            </button>
                        </div>
                        {selectedTour?.other_tags && selectedTour?.other_tags.length > 0 &&
                          <div className="price-details_promotion-tag">
                            <div className="price-details_tag-header">Promotions</div>
                            <div className="price-details_tag-list">
                              {selectedTour.promo_tag && <span key='primary_tag' className="price-details_tag primary_tag" >
                                {selectedTour.promo_tag}
                              </span>}
                              {(showAllTags ? selectedTour.other_tags : selectedTour.other_tags.slice(0, 10)
                              ).map((tag, index) => (
                                <span key={`${tag.name}-${index}`} className="price-details_tag" >
                                  {tag.name}
                                </span>
                              ))}
                            </div>
                            {selectedTour.other_tags.length > 10 && (
                              <button type="button"
                                className="price-details_tag-toggle"
                                onClick={() => setShowAllTags((prev) => !prev)}
                              >
                                {showAllTags ? 'Show Less' : 'Show All'}
                              </button>
                            )}
                          </div>
                        }
                        <div className="price-details-card__content">
                          <PriceChartV3
                            priceCurrency={priceCurrency}
                            prices={prices}
                            roomTypes={roomTypes}
                          />
                        </div>
                    </div>
                </div>
              </aside>
            </div>
            {isMobile && !isLoading && selectedTour && (
              <PromoBannerV3
                priceCurrency={itinerary?.priceCurrency}
                promoPrice={promoPrice}
                normalPrice={normalPrice}
                basePrice={basePrice}
                onClick={()=>setDrawerPriceChart()}
              />
            )}
            {isMobile && hasCabinNavigation && (
              <CruiseCabinSelectorV3
                departure={cruiseDeparture}
                priceCurrency={itinerary?.priceCurrency || "MYR"}
                selectedMultiplier={cruiseMultiplier}
                selectedTourId={cruiseTourId}
                onSelectRoomType={selectCruiseRoomType}
                onSelectCabin={selectCruiseCabin}
                cabinSelectionDisabled={cruiseTourDetailLoading}
              />
            )}
          </>
        )}
      </div>
      <Modal
        title={<span className="section-label">Price Details</span>}
        open={showPriceChart}
        onCancel={() => setShowPriceChart(false)}
        footer={null}
        centered
        className="v3 price-details-modal"
      >
        {selectedTour?.other_tags && selectedTour?.other_tags.length > 0 &&
          <div className="price-details_promotion-tag">
            <div className="price-details_tag-header">Promotions</div>
            <div className="price-details_tag-list">
              {selectedTour.promo_tag && <span key='primary_tag' className="price-details_tag primary_tag" >
                {selectedTour.promo_tag}
              </span>}
              {(showAllTags ? selectedTour.other_tags : selectedTour.other_tags.slice(0, 10)
              ).map((tag, index) => (
                <span key={`${tag.name}-${index}`} className="price-details_tag" >
                  {tag.name}
                </span>
              ))}
            </div>
            {selectedTour.other_tags.length > 10 && (
              <button type="button"
                className="price-details_tag-toggle"
                onClick={() => setShowAllTags((prev) => !prev)}
              >
                {showAllTags ? 'Show Less' : 'Show All'}
              </button>
            )}
          </div>
        }
        <div className="price-details-modal_body" style={{ padding: "0px 20px" }}>
          <img className="price-details-modal_bg-1" src="/iceholidays-assets/images/v3/price-detail-bg-1.svg" alt="" aria-hidden="true" />
          <img className="price-details-modal_bg-2" src="/iceholidays-assets/images/v3/price-detail-bg-2.svg" alt="" aria-hidden="true" />
          
          <PriceChartV3
            priceCurrency={itinerary?.priceCurrency || "MYR"}
            prices={selectedTour?.prices || []}
            roomTypes={selectedTour?.room_types}
            isMobile={isMobile}
          />
        </div>
      </Modal>
    </>
  );
};

export default DepartureDate;